import { Button } from "@/shared/components/ui/button";
import { useLogoutFlow } from "./useLogoutFlow";

// Holding page for applicants until an officer activates them; the API also blocks their data access.
export function PendingPage() {
  const { onLogout, isPending } = useLogoutFlow();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-background px-6 text-center text-foreground">
      <h1 className="text-xl font-semibold">
        Ditt konto väntar på godkännande
      </h1>
      <Button
        variant="link"
        className="mt-2 h-auto p-0 text-muted-foreground hover:text-foreground"
        onClick={onLogout}
        loading={isPending}
      >
        Logga ut
      </Button>
    </div>
  );
}
